<template>
  <div class="w3-col w3-left-align">
    <ContentHeader v-bind:title="$t('serving-time-report')" />
  </div>
  <ReportItem
    :columns="pdfColumns"
    :objects="tableData"
    :file-name="$t('serving-time-report_')"
    :start-day="$helper.lastMonth()"
    :end-day="$helper.today()"
    @emittedDays="onDateUpdate"
  >
    <StandardTable
      :sort-options="true"
      :no-content="'noData'"
      :column-definitions="columnDefinitions"
      :records="tableData"
    />
  </ReportItem>
</template>

<script>
import StandardTable from "../../common/StandardTable.vue";
import ReportItem from "./ReportItem.vue";
import ContentHeader from "../../common/ContentHeader.vue"

export default {
  name: "ServingTime",
  components: { StandardTable, ReportItem, ContentHeader },
  mounted() {
    const days = [this.$helper.lastMonth(), this.$helper.today()];
    this.onDateUpdate(days);
  },
  data() {
    return {
      columnDefinitions: [
        { key: "service", label: this.$t("service"), dataKey: "service" },
        { key: "site", label: this.$t("site"), dataKey: "site" },
        {
          key: "average_serving_time",
          label: `${this.$t("average_serving_time")} (${this.$t("seconds")})`,
          dataKey: "averageServingTime",
        },
        {
          key: "median_serving_time",
          label: `${this.$t("median_serving_time")} (${this.$t("seconds")})`,
          dataKey: "medianServingTime",
        },
      ],
      tableData: [],
      pdfColumns: [
        { title: this.$t("service"), dataKey: "service" },
        { title: this.$t("site"), dataKey: "site" },
        {
          title: `${this.$t("average_serving_time")} (${this.$t("seconds")})`,
          dataKey: "averageServingTime",
        },
        { title: this.$t("median_serving_time"), dataKey: "medianServingTime" },
      ],
    };
  },
  methods: {
    onDateUpdate(days) {
      const queryString = `startDate=${this.$helper.flipDateFormat(
        days[0]
      )}&endDate=${this.$helper.flipDateFormat(days[1])}`;
      this.fetchServingTimeReport(queryString);
    },
    fetchServingTimeReport(queryString) {
      this.$restClient.reports
        .servingTimes({ query: queryString })
        .then((response) => {
            response.data.forEach(w => {
            w.averageServingTime = Math.round(w.averageServingTime);
            w.medianServingTime = Math.round(w.medianServingTime);
          });
          this.tableData = response.data;
        })
        .catch((err) => {
          console.log(err);
          this.$notify.notifyError({
            title: this.$t("failed"),
          });
        });
    },
  },
};
</script>
